export interface RetrieveContentItem {
  id: number;
  documentId?: string;
  question: string;
  audio?: string;
  complexity: string;
  type?: string;
  answer?: any;
}

export const CHATBOX_STRINGS = {
  letsChat: "Let's Chat",
  tellStory: "Tell a Story",
  myStory: "My Story",
  saveYourWork: "Save your work?",
  thatsAmazing: "That's amazing!",
  woohoo: "Woohoo",
} as const;
